import { defineStore } from "pinia";

export interface Moneda {
  nombre: string;
  simbolo: string;
  codigoBcu: string;
  codigoIso: string;
  numeroIso: string;
  activo: boolean;
  cotizacion: number;
}

export const useMonedasDiccionarioStore = defineStore("monedas", {
  state: () => ({
    monedas: [
      {
        nombre: "PESO URUGUAYO",
        simbolo: "$",
        codigoBcu: "1",
        codigoIso: "UYU",
        numeroIso: "858",
        activo: true,
        cotizacion: 1
      },
      {
        nombre: "DOLAR ESTADOUNIDENSE",
        simbolo: "USD",
        codigoBcu: "2225",
        codigoIso: "USD",
        numeroIso: "840",
        activo: true,
        cotizacion: 1
      },
      {
        nombre: "PESO ARG.BILLETE",
        simbolo: "ARS",
        codigoBcu: "501",
        codigoIso: "ARS",
        numeroIso: "32",
        activo: true,
        cotizacion: 1
      },
      {
        nombre: "REAL BILLETE",
        simbolo: "R$",
        codigoBcu: "1001",
        codigoIso: "R$",
        numeroIso: "986",
        activo: true,
        cotizacion: 1
      },
      {
        nombre: "DLS. USA CABLE",
        simbolo: "DLS.",
        codigoBcu: "2224",
        codigoIso: "DLS.",
        numeroIso: "840",
        activo: true,
        cotizacion: 1
      },
      {
        nombre: "DLS. USA BILLETE",
        simbolo: "DLS.",
        codigoBcu: "2225",
        codigoIso: "DLS.",
        numeroIso: "840",
        activo: true,
        cotizacion: 1
      },
      {
        nombre: "DLS.PROMED.FONDO",
        simbolo: "U$A",
        codigoBcu: "2230",
        codigoIso: "U$A",
        numeroIso: "840",
        activo: true,
        cotizacion: 1
      },
      {
        nombre: "UNIDAD INDEXADA",
        simbolo: "U.I.",
        codigoBcu: "9800",
        codigoIso: "UYI",
        numeroIso: "940",
        activo: true,
        cotizacion: 1
      },
      {
        nombre: "UNIDAD REAJUSTABLE",
        simbolo: "U.R.",
        codigoBcu: "9900",
        codigoIso: "UYR",
        numeroIso: "979",
        activo: true,
        cotizacion: 1
      },
      {
        nombre: "DOL. AUSTRALIANO",
        simbolo: "AUD",
        codigoBcu: "105",
        codigoIso: "AUD",
        numeroIso: "36",
        activo: true,
        cotizacion: 1
      },
      {
        nombre: "PESO ARGENTINO",
        simbolo: "ARS",
        codigoBcu: "500",
        codigoIso: "ARS",
        numeroIso: "32",
        activo: true,
        cotizacion: 1
      },
      {
        nombre: "REAL",
        simbolo: "BRL",
        codigoBcu: "1000",
        codigoIso: "BRL",
        numeroIso: "986",
        activo: true,
        cotizacion: 1
      },
      {
        nombre: "EURO",
        simbolo: "€",
        codigoBcu: "1111",
        codigoIso: "EUR",
        numeroIso: "978",
        activo: true,
        cotizacion: 1
      },
      {
        nombre: "PESO CHILENO",
        simbolo: "CLP",
        codigoBcu: "1300",
        codigoIso: "CLP",
        numeroIso: "152",
        activo: true,
        cotizacion: 1
      },
      {
        nombre: "DOL. NEOZELANDES",
        simbolo: "NZD",
        codigoBcu: "1490",
        codigoIso: "NZD",
        numeroIso: "554",
        activo: true,
        cotizacion: 1
      },
      {
        nombre: "RAND SUDAFRICANO",
        simbolo: "R",
        codigoBcu: "1620",
        codigoIso: "ZAR",
        numeroIso: "710",
        activo: true,
        cotizacion: 1
      },
      {
        nombre: "CORONA DANESA",
        simbolo: "kr",
        codigoBcu: "1800",
        codigoIso: "DKK",
        numeroIso: "208",
        activo: true,
        cotizacion: 1
      },
      {
        nombre: "DOLAR USA",
        simbolo: "USD",
        codigoBcu: "2222",
        codigoIso: "USD",
        numeroIso: "840",
        activo: true,
        cotizacion: 1
      },
      {
        nombre: "DOLAR CANADIENSE",
        simbolo: "CAD",
        codigoBcu: "2309",
        codigoIso: "CAD",
        numeroIso: "124",
        activo: true,
        cotizacion: 1
      },
      {
        nombre: "LIBRA ESTERLINA",
        simbolo: "£",
        codigoBcu: "2700",
        codigoIso: "GBP",
        numeroIso: "826",
        activo: true,
        cotizacion: 1
      },
      {
        nombre: "YEN",
        simbolo: "¥",
        codigoBcu: "3600",
        codigoIso: "JPY",
        numeroIso: "392",
        activo: true,
        cotizacion: 1
      },
      {
        nombre: "NVO.SOL PERUANO",
        simbolo: "S/.",
        codigoBcu: "4000",
        codigoIso: "PEN",
        numeroIso: "604",
        activo: true,
        cotizacion: 1
      },
      {
        nombre: "YUAN RENMIMBI",
        simbolo: "¥",
        codigoBcu: "4150",
        codigoIso: "CNY",
        numeroIso: "156",
        activo: true,
        cotizacion: 1
      },
      {
        nombre: "YUAN OFF SHORE",
        simbolo: "¥",
        codigoBcu: "4155",
        codigoIso: "CNH",
        numeroIso: "158",
        activo: true,
        cotizacion: 1
      },
      {
        nombre: "PESO MEXICANO",
        simbolo: "MXN",
        codigoBcu: "4200",
        codigoIso: "MXN",
        numeroIso: "484",
        activo: true,
        cotizacion: 1
      },
      {
        nombre: "FORINT HUNGARO",
        simbolo: "Ft",
        codigoBcu: "4300",
        codigoIso: "HUF",
        numeroIso: "348",
        activo: true,
        cotizacion: 1
      },
      {
        nombre: "LIRA TURCA",
        simbolo: "₺",
        codigoBcu: "4400",
        codigoIso: "TRY",
        numeroIso: "949",
        activo: true,
        cotizacion: 1
      },
      {
        nombre: "CORONA NORUEGA",
        simbolo: "kr",
        codigoBcu: "4600",
        codigoIso: "NOK",
        numeroIso: "578",
        activo: true,
        cotizacion: 1
      },
      {
        nombre: "GUARANI",
        simbolo: "₲",
        codigoBcu: "4800",
        codigoIso: "PYG",
        numeroIso: "600",
        activo: true,
        cotizacion: 1
      },
      {
        nombre: "CORONA ISLANDESA",
        simbolo: "kr",
        codigoBcu: "4900",
        codigoIso: "ISK",
        numeroIso: "352",
        activo: true,
        cotizacion: 1
      },
      {
        nombre: "DOLAR HONG KONG",
        simbolo: "$",
        codigoBcu: "5100",
        codigoIso: "HKD",
        numeroIso: "344",
        activo: true,
        cotizacion: 1
      },
      {
        nombre: "WON",
        simbolo: "₩",
        codigoBcu: "5300",
        codigoIso: "KRW",
        numeroIso: "410",
        activo: true,
        cotizacion: 1
      },
      {
        nombre: "RUBLO",
        simbolo: "₽",
        codigoBcu: "5400",
        codigoIso: "RUB",
        numeroIso: "643",
        activo: true,
        cotizacion: 1
      },
      {
        nombre: "PESO COLOMBIANO",
        simbolo: "$",
        codigoBcu: "5500",
        codigoIso: "COP",
        numeroIso: "170",
        activo: true,
        cotizacion: 1
      },
      {
        nombre: "RINGGIT MALAYO",
        simbolo: "RM",
        codigoBcu: "5600",
        codigoIso: "MYR",
        numeroIso: "458",
        activo: true,
        cotizacion: 1
      },
      {
        nombre: "RUPIA INDIA",
        simbolo: "₹",
        codigoBcu: "5700",
        codigoIso: "INR",
        numeroIso: "356",
        activo: true,
        cotizacion: 1
      },
      {
        nombre: "CORONA SUECA",
        simbolo: "kr",
        codigoBcu: "5800",
        codigoIso: "SEK",
        numeroIso: "752",
        activo: true,
        cotizacion: 1
      },
      {
        nombre: "FRANCO SUIZO",
        simbolo: "CHF",
        codigoBcu: "5900",
        codigoIso: "CHF",
        numeroIso: "756",
        activo: true,
        cotizacion: 1
      },
      {
        nombre: "BOLIVAR",
        simbolo: "Bs.S",
        codigoBcu: "6200",
        codigoIso: "VEF",
        numeroIso: "937",
        activo: true,
        cotizacion: 1
      }
      // Agrega el resto de las monedas...
    ] as Moneda[]
  }),
  getters: {
    todasLasMonedas(state) {
      return [...state.monedas];
    }
  },
  actions: {
    agregarMoneda(nuevaMoneda: Moneda) {
      this.monedas.push(nuevaMoneda);
    }
  }
});
